import React, {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from 'react'

import { useDispatch } from 'react-redux'

import { hideTooltipsAction } from 'actions/tooltipAction'
import { BannerId, BannerPlaces } from 'components/banner/banner.constants'
import { GenericBanner } from 'components/banner/GenericBanner'
import { BannerLoadable } from 'components/banner/PhotoViewer/BannerLoadable'
import { useHandleBack } from 'components/page/PhotoViewer/hooks/useHandleBack'
import { SizeProps } from 'components/page/PhotoViewer/PhotoViewer.types'
import { PhotoViewerModalWrapperView } from 'components/page/PhotoViewer/View/PhotoViewerModalWrapperView'
import { useWindowEvent } from 'hooks/useWindowEvent'

export const PhotoViewerModalWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useDispatch()
  const handleContentClick = () => dispatch(hideTooltipsAction())
  const handleBackClick = useHandleBack()
  const [size, setSize] = useState<SizeProps>({
    width: 0,
    height: 0,
  })

  const setSizeWrapper = () => {
    // Относительные величины в разных браузерах, отображаются с дробными значениями.
    setSize({
      width: Math.ceil(document.documentElement.clientWidth * 0.8),
      height: Math.ceil(document.documentElement.clientHeight * 0.8),
    })
  }

  useEffect(() => {
    setSizeWrapper()
  }, [])

  const handleResize = useCallback(() => {
    setSizeWrapper()
  }, [])

  useWindowEvent('resize', handleResize)

  return (
    <PhotoViewerModalWrapperView
      data-name="modal-photoviewer"
      onBackClick={handleBackClick}
      onContentClick={handleContentClick}
      size={size}
      banner={
        <GenericBanner
          place={BannerPlaces.photoViewerBanner}
          banner={<BannerLoadable bannerId={BannerId.photoViewerBanner} />}
        />
      }
    >
      {children}
    </PhotoViewerModalWrapperView>
  )
}
